import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	releaseAction: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unreleaseAction: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	archiveAction: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unarchiveAction: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	mergeAction: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	editAction: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deleteAction: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deleteActionDisabledTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	genericUpdateFailedFlagTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	releaseFailedFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	archiveFailedFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	archiveTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unarchiveTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	releaseTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unReleaseTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deleteTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deleteFailedTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deleteFailedDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	moreActionsTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	moreActionsLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	releaseAction: {
		id: 'project-versions.table.actions.release-action',
		defaultMessage: 'Release',
		description: '',
	},
	unreleaseAction: {
		id: 'project-versions.table.actions.unrelease-action',
		defaultMessage: 'Unrelease',
		description: '',
	},
	archiveAction: {
		id: 'project-versions.table.actions.archive-action',
		defaultMessage: 'Archive',
		description: '',
	},
	unarchiveAction: {
		id: 'project-versions.table.actions.unarchive-action',
		defaultMessage: 'Unarchive',
		description: '',
	},
	mergeAction: {
		id: 'project-versions.table.actions.merge-action',
		defaultMessage: 'Merge',
		description: '',
	},
	editAction: {
		id: 'project-versions.table.actions.edit-action',
		defaultMessage: 'Edit',
		description: '',
	},
	deleteAction: {
		id: 'project-versions.table.actions.delete-action',
		defaultMessage: 'Delete',
		description: '',
	},
	deleteActionDisabledTooltip: {
		id: 'project-versions.table.actions.delete-action-disabled-tooltip',
		defaultMessage: "You don't have permission to delete a version.",
		description:
			'The tooltip shown when the mouse is hovered on the disabled delete button, and the user has no permission to perform the deletion.',
	},
	genericUpdateFailedFlagTitle: {
		id: 'project-versions.table.actions.generic-update-failed-flag-title',
		defaultMessage: 'Something went wrong',
		description:
			'The title of the error flag when updating the version released or archived status fails',
	},
	releaseFailedFlagDescription: {
		id: 'project-versions.table.actions.release-failed-flag-description',
		defaultMessage:
			'We were not able to update the version released status. Please refresh the page and try again.',
		description: 'The description of the error flag when relase fails',
	},
	archiveFailedFlagDescription: {
		id: 'project-versions.table.actions.archive-failed-flag-description',
		defaultMessage:
			'We were not able to update the version archived status. Please refresh the page and try again.',
		description: 'The description of the error flag when relase fails',
	},
	archiveTitle: {
		id: 'project-versions.table.actions.archive-title',
		defaultMessage: '{name} archived',
		description: '',
	},
	unarchiveTitle: {
		id: 'project-versions.table.actions.unarchive-title',
		defaultMessage: '{name} unarchived',
		description: '',
	},
	releaseTitle: {
		id: 'project-versions.table.actions.release-title',
		defaultMessage: '{name} released',
		description: '',
	},
	unReleaseTitle: {
		id: 'project-versions.table.actions.un-release-title',
		defaultMessage: '{name} unreleased',
		description: '',
	},
	deleteTitle: {
		id: 'project-versions.table.actions.delete-title',
		defaultMessage: '{name} deleted',
		description: '',
	},
	deleteFailedTitle: {
		id: 'project-versions.table.actions.delete-failed-title',
		defaultMessage: "We couldn't delete that version",
		description: '',
	},
	deleteFailedDescription: {
		id: 'project-versions.table.actions.delete-failed-description',
		defaultMessage: 'Something went wrong. Try again.',
		description: '',
	},
	moreActionsTooltip: {
		id: 'project-versions.table.actions.more-actions-tooltip',
		defaultMessage: 'More actions',
		description:
			'Tooltip for the more actions meatball menu button that shows a dropdown menu on click',
	},
	moreActionsLabel: {
		id: 'project-versions.table.actions.more-actions-label',
		defaultMessage: 'More actions for {versionName}',
		description:
			'Label for the more actions meatball menu button that shows a dropdown menu on click',
	},
});
export default messages;
